/**
 *
 * Cultures
 *
 */
import React from 'react';
import {
  generatePath,
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
} from 'react-router-dom';
import { RouteConstants } from '../../routes';

import CulturesList from './pages/CulturesList/CulturesList';
import CulturesDetails from './pages/CulturesDetails/CulturesDetails';
import CreateCulture from './pages/CreateCulture/CreateCulture';
import EditCulture from './pages/EditCulture/EditCulture';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../Authorization/slice/selectors';
import NoPermissionsCard from 'app/components/NoPermissionsCard/NoPermissionsCard';

interface IProps extends RouteComponentProps {}

export function Cultures(props: IProps) {
  const { cultureAdministration } = useSelector(selectPermissions);
  if (cultureAdministration === 0) {
    return <NoPermissionsCard />;
  }

  return (
    <>
      <Switch>
        <Route path={RouteConstants.cultures.list} component={CulturesList} />
        <Route
          path={RouteConstants.cultures.detailsByCompany}
          component={CulturesDetails}
        />
        <Route
          path={RouteConstants.cultures.details}
          component={CulturesDetails}
        />

        <Route
          path={RouteConstants.cultures.editCompanyCulture}
          component={EditCulture}
        />

        <Route
          path={RouteConstants.cultures.editCulture}
          component={EditCulture}
        />

        <Route
          path={RouteConstants.cultures.createCulture}
          component={CreateCulture}
        />
        <Route
          exact
          path={RouteConstants.cultures.index}
          render={props => (
            <Redirect
              to={generatePath(RouteConstants.cultures.list, {
                envId: Number(props.match.params.envId),
              })}
            />
          )}
        />
      </Switch>
    </>
  );
}
